import React from "react";
import { motion } from "framer-motion";
import { TRUST_POINTS } from "../../data/content";

export const TrustStrip = () => {
  return (
    <section className="border-b bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="trust-strip">
          {TRUST_POINTS.map((point, i) => {
            const Icon = point.icon;
            return (
              <motion.div
                key={point.title}
                className="flex items-start gap-3"
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.35, delay: i * 0.06 }}
              >
                <div className="h-10 w-10 rounded-lg bg-secondary flex items-center justify-center shrink-0">
                  <Icon className="h-5 w-5 text-[color:var(--brand-navy)]" />
                </div>
                <div>
                  <p className="font-heading font-semibold text-sm text-[color:var(--brand-navy)]">{point.title}</p>
                  <p className="text-xs text-muted-foreground mt-0.5 leading-relaxed">{point.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
